module.exports = __webpack_public_path__ + "img/yhsl.e2939664.png";